import { Button } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import { FC } from 'react';

import { SearchButton } from 'shared/components/SearchButton';
import { selectSearchMetaRefreshing, selectSearchResultsText } from 'shared/selectors/searchMeta';

interface ISearchButtonContainerProps {
  onClick: VoidFunction;
}

export const SearchButtonContainer: FC<ISearchButtonContainerProps> = ({ onClick }) => {
  const isLoading = useSelector(selectSearchMetaRefreshing);
  const searchButtonLabel = useSelector(selectSearchResultsText);

  return (
    <SearchButton>
      <Button theme="fill_primary" size="XS" loading={isLoading} disabled={isLoading} onClick={onClick}>
        {searchButtonLabel}
      </Button>
    </SearchButton>
  );
};
